exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.search-wrapper .product-single-container {\n  height: calc(100vh - 120px);\n  width: 100vw;\n  display: flex;\n  flex-flow: column;\n  overflow-y: scroll;\n}\n.search-wrapper .product-single-container .product-wrapper {\n  padding: 0 20px;\n}\n.search-wrapper .product-single-container .product-wrapper .footer-buttons-container .footer-button {\n  flex: 1;\n  margin: 0 5px;\n}", ""]);

// exports
